import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'jt-badge',
  templateUrl: './jt-badge.component.html',
  styleUrls: ['./jt-badge.component.css'],
  standalone: true,
  imports: [CommonModule, TranslateModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class JtBadgeComponent {

  @Input() variant: 'primary' | 'secondary' | 'success' | 'danger'
    | 'warning' | 'info' | 'light' | 'dark' = 'secondary';
  @Input() pill: boolean = false;
  @Input() extraClass: string = '';
  @Input({ required: true }) ariaLabel!: string;
}
